module.exports = __webpack_public_path__ + "static/media/4.Bell end.8c14140b.mp3";